module.exports = __webpack_public_path__ + "img/notice_photograph.c3accfb4.svg";